export default __webpack_public_path__ + "static/media/Sound.dbb8c593.png";